import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { SketchPicker } from 'react-color';
import { useDropdownFeatures } from '../DropdownMenu/index.js';
import { genericMemo } from '../../utils/index.js';
import RawButton from '../RawButton/index.js';
import Popup from '../Popup/index.js';
import styles from './styles.css.js';

function ColorInput(props) {
  const {
    className,
    value,
    onChange,
    name
  } = props;
  const handleColorChange = React.useCallback(newValue => {
    onChange(newValue.hex, name);
  }, [onChange, name]);
  const {
    buttonRef,
    popupRef,
    showPopup,
    handleButtonClick
  } = useDropdownFeatures(true);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RawButton, {
    elementRef: buttonRef,
    name: undefined,
    className: _cs(styles.colorInput, !value && styles.empty, className),
    style: value ? {
      backgroundColor: value
    } : undefined,
    onClick: handleButtonClick
  }), /*#__PURE__*/React.createElement(Popup, {
    elementRef: popupRef,
    parentRef: buttonRef,
    show: showPopup,
    freeWidth: true,
    className: styles.colorPickerPopup,
    contentClassName: styles.content
  }, /*#__PURE__*/React.createElement(SketchPicker, {
    color: value,
    onChange: handleColorChange,
    disableAlpha: true
  })));
}

var index = genericMemo(ColorInput);

export { index as default };
//# sourceMappingURL=index.js.map
